<template>
  <div>
    <input
      class="input-box"
      v-model="internalValue"
      :placeholder="text"
      @change="onChangeValue"
      v-on:keydown.enter="onKeyDown"
      autocomplete="address-line3"
    />
  </div>
</template>

<script>
export default {
  name: "input-box",
  props: {
    text: { type: String },
    value: {
      type: [String, Number, Boolean],
      default: undefined,
    },
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        if (this.value !== newVal) this.$emit("input", newVal);
      },
    },
  },
  methods: {
    onChangeValue(e) {
      if (e.currentTarget) this.$emit("change-value", e.currentTarget.value);
    },
    onKeyDown() {
      this.$emit("keydown");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.input-box {
  width: 100%;
  padding: 0.5rem 0.75rem;
  margin: 0.25rem 0;
  box-sizing: border-box;
  background: #f5f5f5;
  border: none;
  border-radius: 100px;
  font-size: 1rem;
  &::placeholder {
    color: #a3a3a3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/InputBox.vue